import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRidersSearchQuery } from '../api/services/Riders';
import { RiderSearchResult } from '../types/rider';

interface IUseRiderSearchQuery {
  accountId: number;
  q: string;
}

export const useRiderSearchQuery = (queryParams: IUseRiderSearchQuery) => {
  return useApiGet<{ data: RiderSearchResult[] }>(
    ['ridersSearch', queryParams.q],
    () => getRidersSearchQuery(queryParams),
    {
      enabled: true,
    }
  );
};
